import TinyDatePicker from '../libs/tiny-date-picker/tiny-date-picker.min.js';
import { NavToggle, nextFocusableElement } from '../../../mu-2022/src/scripts/inc/nav-toggle';

// helper functions to toggle a class name on an element
function removeClass(el, classname) {
    if (typeof el === 'undefined') return;
    el.className = el.className.replace(" " + classname, "");
}
function addClass(el, classname) {
    el.className += " " + classname;
}
function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

function qs_val(param) {
    /* qs_val() grabs query string values 
     * based on passed in param arg
     * 
     * @param {String} param 
     * @return {String} value associated with qs param
     * */
    // try URLSearchParams first
    if ('URLSearchParams' in window) {
        var urlParams = new URLSearchParams(window.location.search);
        var theVal = urlParams.get(param);
        return theVal;
    }
    // if no URLSearchParams support, use regex
    var url = window.location.href;
    var regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url)
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    var theVal = decodeURIComponent(results[2]);
    return theVal;
}

// URL for events rest API
var eventsURL = 'mu/v1/events/';

var headingRGX = /<h2 class="content-supplemental-header events-list-header">(.+)<\/h2>/;
var curPageRGX = / data-next-page="(\d+)"/;
var totalPageRGX = / data-total-pages="(\d+)"/;

// if loading events with pre-selected date, retrieve it, otherwise ''
var dateformat = /\d\d\/\d\d\/\d\d\d\d/;
var currentDate = qs_val('date') != null ? qs_val('date') : '';
if (!currentDate.match(dateformat)) {
    currentDate = ''
}
// if loading events with pre-selected event-type, retrieve it, otherwise ''
var currentETEl = document.querySelector('.current-filter');
var currentET = currentETEl ? currentETEl.getAttribute('data-slug') : '';
var eventListing = document.querySelector('.events-list-events');

// clear filter button
var clearBTN = document.getElementById('clearFilters');
// button to load more events
var loadmoreBTN = document.getElementById('loadMoreUpcomingBTN');
// load more wheel
var loader = document.querySelector('.loader');

var datepicker = TinyDatePicker('#eventsDatepicker', {
    appendTo: document.getElementById('eventsDatepicker'),
    // Lang can be used to customize the text that is displayed
    // in the calendar. You can use this to display a different language.
    lang: {
      days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    },
    mode: 'dp-permanent',
    hilightedDate: (currentDate != '') ? new Date(currentDate) : new Date(),

    // min {string|Date} specifies the minimum date that can be selected (inclusive).
    // All earlier dates will be disabled.
    min: '1/1/' + ( new Date().getFullYear() - 1 ),

    // max {string|Date} specifies the maximum date that can be selected (inclusive).
    // All later dates will be disabled.
    max: '12/31/' + ( new Date().getFullYear() + 1 ),

    shouldFocusOnRender: false,

});


function onDPSelect(_, dp) {
    if (selectedDate != dp.state.selectedDate) {
        var selectedDate = dp.state.selectedDate;
        // get the month, day, and year of the selected date
        var month = (selectedDate.getMonth() + 1).toString();
        var day = selectedDate.getDate().toString();
        var year = selectedDate.getFullYear().toString();
        // add 0 in front of day and month strings if only one char
        month = (month.length == 1) ? '0' + month : month;
        day = (day.length == 1) ? '0' + day : day;

        // get formatted date
        currentDate = month + '/' + day + '/' + year;

        events.update(true);
        changeURL('date', currentDate);
    }
}
datepicker.on('select', onDPSelect);

// enable filter buttons to save currentET and to clear the event type filters
var filterSection = document.querySelector('.filter-category');
filterSection.addEventListener('click', function(e) {
    // select a filter
    if (hasClass(e.target, 'filter-category-item') && currentET != e.target.getAttribute('data-slug')) {
        currentET = e.target.getAttribute('data-slug');
        // add current-filter class to chosen event type, remove from all others
        removeCurrentETClasses();
        addClass(e.target, 'current-filter');
        clearBTN.style.display = 'inline-block';
        events.update(true);
        changeURL('eventtype', currentET);
    }
})

var events = {
    
    el: document.querySelector('.events-list-events'),
    url: document.querySelector('.events-list-homepage').dataset.url + 'mu/v1/events',

    update: function(clear){
        if (clear) {
            eventListing.innerHTML = '';
            currentPage = 1;
        }
        // disable the button and change its text
        loadmoreBTN.innerText = "Loading";
        loadmoreBTN.setAttribute("disable", true);

        // var data = new FormData(e.target);
        var xhr = new XMLHttpRequest();

        // add parameters
        var theURL = this.url + "?page=" + getNextPage() + '&per_page=20';
        if (currentDate.length) {
            theURL += "&date=" + currentDate;
        }
        if (currentET.length) {
            theURL += '&eventtype=' + currentET;
        }
        xhr.open("GET", theURL);
        //xhr.responseType = "json";

        // Call a function when the state changes.
        xhr.onreadystatechange = function () { 
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                var response = this.response;
                if (response == 'false' && eventListing.innerText == '') {
                    if (!hasClass(eventListing, 'noevents')) {
                        addClass(eventListing, 'noevents')
                    }
                    eventListing.innerHTML = '<div class="listingContainer" data-next-page="2">' +
                        '<header class="content-supplemental-header events-list-header">No events found...</header>' +
                    '</div>';
                    eventListing.scrollIntoView(true);
                    return;
                }
                if (response == 'false') {
                    return;
                }
                if (eventListing.innerText != '') {
                    // get first heading in the response text
                    var newHeadings = response.match(headingRGX);
                    var firstHeading = newHeadings.length > 0 ? newHeadings[1] : '';
                    // get last heading of the eventListing
                    var curHeadings = eventListing.querySelectorAll('.events-list-header');
                    lastHeading = curHeadings[curHeadings.length - 1].innerText;
                    if (firstHeading.toLowerCase() == lastHeading.toLowerCase()) {
                        response = response.replace('<header class="content-supplemental-header events-list-header">' + firstHeading + "</header>", '');
                    }
                }
                if (hasClass(eventListing, 'noevents')) {
                    removeClass(eventListing, 'noevents')
                }
                // check curpage against total pages
                var curPage = response.match(curPageRGX);
                var totalPage = response.match(totalPageRGX);
                var curPage = curPage.length > 0 ? curPage[1] : null;
                var totalPage = totalPage.length > 0 ? totalPage[1] : null;
                noBtnDisplay = (curPage > totalPage || curPage == null) ? true : false;
                // get last heading of the current events list
                eventListing.innerHTML += response;
                // hide button if total page = current page
                loadmoreBTN.style.display = noBtnDisplay ? 'none' : '';
                loadmoreBTN.innerText = noBtnDisplay ? "Loading" : "Load More Events";
                // change the focus to the first a tag that was just loaded
                let firstNewEvent = document.querySelector(".events-list-events > .listingContainer:last-of-type a");
                firstNewEvent.focus();                
            }
        }
        xhr.send();
    }

}

// toggle showing the filters
var filterbuttonopen = document.getElementById('filter-button-open');
var filterbuttonclose = document.getElementById('filter-button-close');
var filterbody = document.querySelector(".front-filters");

let globalNavToggle = new NavToggle( {
	'el': filterbody,
	'button': filterbuttonopen,
    'closeButton': filterbuttonclose,
    'title': 'Event Filters',
} );




// remove current-filter class
function removeCurrentETClasses() {
    var categoryBtns = document.querySelectorAll('.filter-category-item')
    for (var i = 0; i < categoryBtns.length; i++) {
        removeClass(categoryBtns[i], 'current-filter');
    }
    // hide the clear btn
    clearBTN.style.display = 'none';
}

// get current page
function getNextPage() {
    var listingContainers = document.querySelectorAll('.listingContainer');
    if (!listingContainers.length) {
        return 1;
    }
    var lastContainer = listingContainers[listingContainers.length - 1];
    return lastContainer.getAttribute('data-next-page');
}

loadmoreBTN.addEventListener('click', function (e) {
    events.update(false);
})

clearBTN.addEventListener('click', function(e) {
    currentET = '';
    removeCurrentETClasses();
    events.update(true);
    changeURL('clear', '');
    clearBTN.style.display = '';
})

// pushstate function
function changeURL(filter, val) {
    var href = window.location.href;
    href = decodeURIComponent(href);
    var newFilter = '';
    switch (filter) {
        case 'date':
            href = href.replace(/(\?|\&)date\=([^&]+)/gm, "");
            newFilter = 'date=' + val;
            break;
        case 'eventtype':
            href = href.replace(/(\?|\&)eventtype\=([^&]+)/gm, "");
            newFilter = 'eventtype=' + val;
            break;
        case 'clear':
            // only clearing eventtype filters
            href = href.replace(/(\?|\&)eventtype\=([^&]+)/gm, "");
            window.history.pushState({}, '', href);
            return;
    }
    if (!href.match(/\?/g) && newFilter.length) {
        href += '?' + newFilter;
    } else if (newFilter.length) {
        href += '&' + newFilter;
    }
    // make sure ? comes first, then &
    if (href.match(/\/\&/g)) {
        href = href.replace(/\?/g, '&');
        href = href.replace(/\/\&/g, '/?');
    }
    window.history.pushState({}, '', href);
}

// update events if need be to account for popstate
window.addEventListener('popstate', function (e) {
    var popDate = qs_val('date');
    var popET = qs_val('eventtype');
    currentDate = (popDate && popDate.match(dateformat)) ? popDate : '';
    currentET = (popET) ? popET : '';
    // make calendar reflect new date (disable select event to prevent URL Change issues)
    datepicker.off('select');
    datepicker.setState({selectedDate: new Date(currentDate)});
    datepicker.on('select', onDPSelect);
    // make catetgory filter reflect new filter
    removeCurrentETClasses();
    if (currentET != '') {
        var curETEl = document.querySelector('.filter-category-item[data-slug="' + currentET + '"]')
        addClass(curETEl, 'current-filter');
        clearBTN.style.display = 'inline-block';
    } else {
        clearBTN.style.display = '';
    }
    events.update(true);
});
// disable filter buttons if they are there, depending on window size
function widthCheck() {
    if (1024 >= window.innerWidth) {
        if (filterbuttonopen && filterbuttonopen.hasAttribute('disabled')) {
            filterbuttonopen.removeAttribute('disabled');
        }
        if (filterbuttonclose && filterbuttonclose.hasAttribute('disabled')) {
            filterbuttonclose.removeAttribute('disabled');
        }
    } else {
        if (filterbuttonopen && !filterbuttonopen.hasAttribute('disabled')) {
            filterbuttonopen.setAttribute('disabled', 'disabled');
        }
        if (filterbuttonclose && !filterbuttonclose.hasAttribute('disabled')) {
            filterbuttonclose.setAttribute('disabled', 'disabled');
        }
    }
}
widthCheck();
window.addEventListener('resize', widthCheck, {passive: true})
